import moment from "moment";

class FormatHelpers {
  static dateFormatter({ unixTime, dateRange, format }) {
    const startDate = moment(dateRange[0]);
    const endDate = moment(dateRange[1]);
    const numberOfMonths =
      endDate.startOf("month").diff(startDate.startOf("month"), "months") + 1;
    if (numberOfMonths >= 3)
      return moment(unixTime).format(format || "MMMM YYYY");

    return moment(unixTime).format("MM/DD/YYYY");
  }

  static durationFormatter(duration) {
    if (duration)
      return duration > 60
        ? duration > 3600
          ? `${(duration / 3600).toFixed(2)} hours`
          : `${(duration / 60).toFixed(2)} mins`
        : `${duration.toFixed(2)} secs`;

    return "0.00 secs";
  }
}

export default FormatHelpers;
